import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ShoppingCartService } from './../../services/shoppingcart.service';
import { Subscription } from 'rxjs';
import { LoadplanningService } from '../../services/loadplanning.service';
import { MatDialog } from '@angular/material/dialog';
import { LoadplanningDialogComponent } from '../loadplanning-dialog/loadplanning-dialog.component';
import { MediaService } from '../../services/media.service';

@Component({
  selector: 'app-cart-summary',
  templateUrl: './cart-summary.component.html',
  styleUrls: ['./cart-summary.component.scss']
})
export class CartSummaryComponent implements OnInit, OnDestroy {

  private subscriptions = new Map<string, Subscription>();

  @Input() header: string;

  totals: any;

  constructor(
    private shoppingCartService: ShoppingCartService,
    public loadPlanningService: LoadplanningService,
    public mediaService: MediaService,
    public dialog: MatDialog
    ) { }

  ngOnInit() {
    this.totals = this.shoppingCartService.getTotals();
    this.subscriptions.set('shoppingCartItemsChanged',
      this.shoppingCartService.itemsTotalsChanged.subscribe((totals: any) => {
        this.totals = totals;
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  showLoadplanning() {
    this.dialog.open(LoadplanningDialogComponent);
  }

}
